export default __webpack_public_path__ + "static/media/Card_2.569a3a91.jpg";